export default "<div *ngIf=\"error\" class=\"text-danger\">Error during logout</div>\r\n"